
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutor-on-demand/math",
      function () {
        return require("private-next-pages/tutor-on-demand/math.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutor-on-demand/math"])
      });
    }
  